import { getThemeColors } from './abTesting';

// Get colors based on A/B test variant
const colors = getThemeColors();

export const globalStyles = {
  colors,
  styles: {
    global: {
      body: {
        overflowX: 'hidden',
        bg: 'background.100',
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
        letterSpacing: '-0.5px',
      },
      input: {
        color: 'gray.700',
      },
      html: {
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      },
    },
  },
};
